import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';

export interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  actionButton?: {
    label: string;
    icon?: string;
    to?: string;
    onClick?: () => void;
  };
  breadcrumbs?: Array<{
    label: string;
    to?: string;
  }>;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, description, actions, actionButton, breadcrumbs }) => {
  return (
    <div className="mb-4">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <div className="flex items-center text-xs text-gray-500 mb-1">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={index}>
              {index > 0 && <span className="mx-1">/</span>}
              {crumb.to ? (
                <Link to={crumb.to} className="hover:text-blue-600">
                  {crumb.label}
                </Link>
              ) : (
                <span>{crumb.label}</span>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
      
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-xl font-bold text-gray-800">{title}</h1>
          {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
        </div>
        
        {/* Display either actions or actionButton, giving precedence to actions */}
        {actions ? (
          <div>{actions}</div>
        ) : actionButton && (
          actionButton.to ? (
            <Link to={actionButton.to}>
              <Button
                variant="primary"
                leftIcon={actionButton.icon && (
                  <i className={`fas fa-${actionButton.icon}`}></i>
                )}
              >
                {actionButton.label}
              </Button>
            </Link>
          ) : (
            <Button
              variant="primary"
              onClick={actionButton.onClick}
              leftIcon={actionButton.icon && (
                <i className={`fas fa-${actionButton.icon}`}></i>
              )}
            >
              {actionButton.label}
            </Button>
          )
        )}
      </div>
    </div>
  );
};

export default PageHeader;